<template>
  <pages-education-slug-component
    v-if="data"
    :data="data"
    :close-path="closePath"
    :on-edition-page="true"
  />
  <shared-error-component v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const route = useRoute()

const closePath = getClosePath('editions-slug-index-education', { slug: route?.params?.slug })

// 1
const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryEducationEntryBySlug(getPageQuery({slug: route?.query?.educationSlug})) } } ) )
data.value = getFirstObject(data.value?.data)
</script>
